module.exports = __webpack_public_path__ + "static/home10.120a139f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home10.png
// module id = 483
// module chunks = 35783957827783